module.exports = __webpack_public_path__ + "img/score_8.c196bec0.png";